<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI"
import Pagination from "@/components/standard/SgsstResponsabilities/SgsstResponsabilitiesAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import Swal from "sweetalert2";
import { sendNotification } from "@/utils/helpers/notification"
import CheckModal from "@/components/CheckModal"
import { dateFormat } from "@/utils/helpers/format";
import ItemAPI from "@/services/items/itemsAPI";
import CompanyAPI from "@/services/company/companyAPI";
import EmployeeAPI from "@/services/employee/employeeAPI";
import sgsstResponsibilitiesAPI from "@/services/standards/sgsst-responsibilities/sgsstResponsibilitiesAPI";
import itemFormatsAPI from "@/services/itemFormats/itemFormatsAPI";
import DocumentActions from "@/components/document/DocumentActions.vue";

/**
 * Form elements component
 */
export default {
  page: {
    title: "Responsabilidades en el SG SST",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
    Pagination,
    DocumentActions,
  },
  data() {

    return {
      title: "1.1.2 Responsabilidades en el SG SST",
      items: [
        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Responsabilidades en el SG SST",
          active: true,
        },
      ],
      lista: [],
      file: null,
      loading1: true,
      guardando: false,
      item: null,
      itemStatus: "No cumplido",
      itemData: null,
      company: "",

      preventionbrigade: {
        file: "datos",
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      sgsstResponsibilities: {
        resp_link: null,
        resp_rol: null,
        employee_id: null,
      },

      usersList: null,
      company: this.$store.getters["company/getCompany"] || null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      search: "",
      loading: true,

      // Acta general (tandas)
      actas: [],
      actaFile: null,
      actaForm: { city: null, acta_date: null, socializa: null, socializa_cargo: null, employee_ids: [] },
      actaUploading: false,
      actaSearch: "",
      showCovered: false,
      showPending: false,
    };
  },
  methods: {

    fetch() {
      this.loading = true;
      this.$refs.paginator.query();
    },

    getItemData() {
      ItemAPI.getItems(2)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 2)
        .then(response => {
          this.item = response || null
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
        })
        .catch(error => {
          console.log(error)
        })
    },

    changeItemStatus(itemStatus) {
      const itemChange = {
        companies_id: this.companyID,
        item_id: 2,
        status: itemStatus,
      }
      newScoresAPI.calculateScores(itemChange)
        .then((response) => {
          Swal.fire({
            title: "¡Éxito!",
            text: "¡Se ha cambiado el estado del ítem con éxito!",
            icon: "success",
            type: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          setTimeout(() => window.location.reload(), 2000)
        })
        .catch((error) => {
          Swal.fire({
            title: "¡ERROR!",
            text: "¡No se ha actualizado el estado del ítem!",
            icon: "error",
            type: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          setTimeout(() => window.location.reload(), 2000)
          console.log(error);
        });
    },

    /**
         * This method is used to send notification to SST user and SST company.
         * The sendNotification method import is required.
         * @param {Number} messageID - The message ID that will be associated to notification.
         * @param {Number} itemID - The item ID that will be associated to notification.
         * @param {Boolean} user - The user that will e associated to notification.
         * @return {Boolean} True if the notification is sent, false if not.
         */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },

    /**
    * This method is used to knows if the user has the permission indicated
    * @param {String} name The name of the permission
    * @param {Array} roles the roles that permitted to access the action 
    * @returns {Boolean} true if the user has the permission indicated or false if no
    */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions
        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

    /**
   * This method is used to redirect to the page indicated
   * @param {String} page The page to redirect
   */
    goPage(page) {
      window.location.href = page
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";
        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.company.nit}/1.1.2/${this.sgsstResponsibilities.employee_id}/${this.file.name}`;
        } else {
          url = `sst-prod/${this.company.nit}/1.1.2/${this.sgsstResponsibilities.employee_id}/${this.file.name}`;
        }
        const result = await uploadDocument(url, this.file);
        if (result) {
          this.sgsstResponsibilities.resp_link = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    getList() {
      sgsstResponsibilitiesAPI.getAllResponsabilities(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          this.loading1 = false
          let responsabilidad = response.data.data;
          this.lista = responsabilidad
        })
        .catch((error) => {
          console.log(error);
          this.loading1 = false
        });
    },

    async save() {
      this.guardando = true
      this.loading1 = true
      let document = await this.uploadDocument();
      if (document) {
        sgsstResponsibilitiesAPI.save(this.sgsstResponsibilities)
          .then((response) => {
            if (response.sgsst === 'Sgsst responsibility saved successfull') {
              const itemChange = {
                companies_id: this.companyID,
                item_id: 2,
                status: 'Pendiente',
              }
              newScoresAPI.calculateScores(itemChange)
                .then(response => {
                  this.loading1 = false
                  setTimeout(() => {
                    Swal.fire({
                      title: "¡Éxito!",
                      text: "¡Se ha registrado con éxito!",
                      icon: "success",
                      type: "success",
                      confirmButtonClass: "btn btn-confirm mt-2",
                    });
                    window.location.reload()
                  }, 1000)
                })
                .catch(error => {
                  console.log(error)
                })
            }
          })
          .catch((error) => {
            console.log(error);
            this.loading1 = false
          });
      } else {
        setTimeout(() => {
          this.loading1 = false
          Swal.fire({
            title: "¡Error!",
            text: "¡No se ha podido registrar!",
            type: "error",
            type: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          window.location.reload()
        }, 3000)
      }
    },

    async print() {
      try {
        const res = await itemFormatsAPI.list('1.1.2')
        const f = ((res && res.data) || []).find(x => x.label === 'Formato individual')
        if (f) window.location.href = itemFormatsAPI.url(f.bucket_key)
      } catch (error) {
        console.log(error);
      }
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    getUsers() {
      CompanyAPI.getCompany(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          EmployeeAPI.getEmployeesOcupationalMedical(response.id)
            .then((res) => {
              this.usersList = res.employee
            })
        })
        .catch((error) => {
          console.log(error);
        });
    },

    // ── Acta general (tandas) ──

    async printGeneral() {
      try {
        const res = await itemFormatsAPI.list('1.1.2')
        const f = ((res && res.data) || []).find(x => x.label === 'Formato general')
        if (f) window.location.href = itemFormatsAPI.url(f.bucket_key)
      } catch (error) {
        console.log(error);
      }
    },

    getActas() {
      sgsstResponsibilitiesAPI.actasIndex(this.companyID)
        .then((res) => { this.actas = (res && res.data) || [] })
        .catch((error) => { console.log(error) })
    },

    async uploadActaDocument() {
      try {
        const env = process.env.VUE_APP_ENV === 'development' ? 'sst-dev' : 'sst-prod'
        const safeName = this.actaFile.name.replace(/\s+/g, '_')
        const url = `${env}/${this.company.nit}/1.1.2/general/${Date.now()}-${safeName}`
        const ok = await uploadDocument(url, this.actaFile)
        return ok ? `${process.env.VUE_APP_BUCKET}/${url}` : null
      } catch (error) {
        console.log(error)
        return null
      }
    },

    async saveActa() {
      if (!this.actaForm.employee_ids.length) {
        Swal.fire("Atención", "Selecciona los colaboradores de esta tanda", "info"); return
      }
      this.actaUploading = true
      try {
        const res = await sgsstResponsibilitiesAPI.actasStore({
          companies_id: this.companyID,
          city: this.actaForm.city || null,
          socializa: this.actaForm.socializa || null,
          socializa_cargo: this.actaForm.socializa_cargo || null,
          acta_date: this.actaForm.acta_date || null,
          employee_ids: this.actaForm.employee_ids,
        })
        if (res && res.data) {
          this.actas.unshift(res.data)
          this.actaForm = { city: null, acta_date: null, socializa: null, socializa_cargo: null, employee_ids: [] }
          Swal.fire({ icon: "success", title: "Tanda creada", text: "Descarga el borrador o fírmala desde la columna Documento.", timer: 2200, showConfirmButton: false })
        } else {
          Swal.fire("Error", (res && res.message) || "No se pudo crear la tanda", "error")
        }
      } catch (error) {
        console.log(error)
        Swal.fire("Error", "No se pudo crear la tanda", "error")
      } finally {
        this.actaUploading = false
      }
    },

    onActaSigned(acta, payload) {
      this.$set(acta, 'workflow_status', payload.workflow_status)
      this.$set(acta, 'signed_at', payload.signed_at)
    },

    async deleteActa(id) {
      const ok = await Swal.fire({
        icon: "warning", title: "¿Eliminar esta tanda?",
        text: "Se quitará el acta general de los colaboradores asociados.",
        showCancelButton: true, confirmButtonText: "Eliminar", cancelButtonText: "Cancelar",
      })
      if (!ok.isConfirmed) return
      try {
        await sgsstResponsibilitiesAPI.actasDelete(id)
        this.actas = this.actas.filter((a) => a.id !== id)
        Swal.fire({ icon: "success", title: "Eliminada", timer: 1200, showConfirmButton: false })
      } catch (error) {
        console.log(error)
        Swal.fire("Error", "No se pudo eliminar", "error")
      }
    },
  },

  computed: {
    // Wrapper para reutilizar DocumentActions con los endpoints del acta general
    actaApi() {
      return {
        pdfUrl: (id) => sgsstResponsibilitiesAPI.actaPdfUrl(id),
        sign: (id, payload) => sgsstResponsibilitiesAPI.actaSign(id, payload),
      }
    },
    coveredIds() {
      const s = new Set()
      this.actas.forEach((a) => {
        const emps = a.employees || []
        emps.forEach((e) => s.add(e.id))
      })
      return s
    },
    availableEmployees() {
      const list = this.usersList || []
      let filtered = this.showCovered ? list : list.filter((e) => !this.coveredIds.has(e.id))
      if (this.actaSearch) {
        const q = this.actaSearch.toLowerCase()
        filtered = filtered.filter((e) => (e.full_name || "").toLowerCase().includes(q))
      }
      return filtered
    },
    pendingEmployees() {
      return (this.usersList || []).filter((e) => !this.coveredIds.has(e.id))
    },
    coverage() {
      const total = (this.usersList || []).length
      const covered = (this.usersList || []).filter((e) => this.coveredIds.has(e.id)).length
      return { total, covered, pending: total - covered }
    },
  },

  mounted() {
    this.getItems()
    this.getList();
    this.getItemData();
    this.getUsers();
    this.getActas();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading1">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">

                  <CheckModal>
                    <p class="text-justify">
                      Se deben definir las responsabilidades en cuanto a Seguridad y Salud en el Trabajo en todos los
                      niveles de la organización. Estas responsabilidades deben estar documentadas y asignadas a cada
                      uno
                      de los colaboradores de la empresa.

                      Subir las evidencias de la entrega de las responsabilidades a cada uno de los colaboradores. </p>
                  </CheckModal>
                </div>

                <div class="col-6 text-right m-b-0">

                  <button :disabled="!allowAccess()" @click="print" class="btn btn-primary mx-1" id="tooltip">
                    <span class="btn-label"> <i class="bx bx-download"></i></span> Formato individual
                  </button>

                  <button :disabled="!allowAccess()" @click="printGeneral" class="btn btn-primary mx-1" id="tooltipGeneral">
                    <span class="btn-label"> <i class="bx bx-download"></i></span> Formato general
                  </button>

                  <b-tooltip target="tooltip" placement="left">
                    Descargar formato individual de roles y responsabilidades SG-SST
                  </b-tooltip>
                  <b-tooltip target="tooltipGeneral" placement="left">
                    Descargar formato del acta general (firma de todos los colaboradores)
                  </b-tooltip>
                </div>

              </div>

              <div class="row">
                <div class="col-6">
                </div>

                <div class="form-row col-md-6 col-sm-12 pt-1">
                  <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>

              </div>

              <form class="form-group" @submit.prevent="save">
                <div class="form-row pt-3">
                  <b-form-group label-for="employee" class="col-md-6 px-2" label="Colaborador">
                    <select :disabled="!getRole('Crear') || !allowAccess()" required
                      v-model="sgsstResponsibilities.employee_id" class="form-control">
                      <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                        {{ item.full_name }}
                      </b-form-select-option>
                    </select>
                  </b-form-group>

                  <b-form-group label-for="number" class="col-md-6 px-2" label="Roles en el SG-SST">
                    <select id="type" class="form-control" v-model="sgsstResponsibilities.resp_rol">
                      <b-form-select-option value="Management">
                        Nivel Gerencial
                      </b-form-select-option>
                      <b-form-select-option value="Media">
                        Mandos medios
                      </b-form-select-option>
                      <b-form-select-option value="Colaborators">
                        Colaboradores
                      </b-form-select-option>
                      <b-form-select-option value="Sgsst">
                        Responsable del SG-SST
                      </b-form-select-option>
                      <b-form-select-option value="Copasst">
                        Comité Paritario de Seguridad y Salud en el Trabajo
                      </b-form-select-option>
                      <b-form-select-option value="Cocola">
                        Comité de Convivencia Laboral
                      </b-form-select-option>
                      <b-form-select-option value="Brigade">
                        Brigadista
                      </b-form-select-option>
                    </select>
                  </b-form-group>

                  <b-form-group class="col-md-12 px-2" label="Subir roles y responsabilidades" label-for="file">
                    <b-form-file :disabled="!getRole('Crear') || !allowAccess()" required type="file" id="file"
                      ref="file" name="file" browse-text="Buscar" :placeholder="`Selecciona un archivo...`"
                      drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      v-on:change="uploadFile">
                    </b-form-file>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="guardando" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>

                <hr v-if="getRole('Consultar')" />

                <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                  <div class="col-lg-12">
                    <div class="card-body">
                      <div class="row pb-3">
                        <div class="col-6">
                          <div class="form-row row text-center">
                            <form @submit.prevent="fetch()" class="form-inline">
                              <div class="col-sm-11 col-md-5">
                                <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                                  class="form-control px-2" placeholder="Buscar"></b-form-input>
                              </div>
                              <div class="col-sm-1 ml-5">
                                <button type="submit" class="btn btn-primary px-2">Buscar</button>
                              </div>

                            </form>
                          </div>
                        </div>

                      </div>

                      <div class="table-responsive">
                        <!--<div v-if="!loading">-->
                        <table class="
                            pt-2
                            table
                            border-bottom
                            divide-y divide-gray-200
                            table-striped
                            rounded
                          ">
                          <thead>
                            <tr>

                              <th class="text-center align-middle">Colaborador</th>

                              <th class="text-center align-middle">Rol</th>
                              <th class="text-center align-middle">Archivo</th>
                              <th class="text-center align-middle">Acciones</th>
                            </tr>
                          </thead>
                          <tbody class="bg-white divide-y divide-gray-200">
                            <tr v-for="dato in lista" :key="dato.id">

                              <td class="text-center align-middle">
                                {{ dato.full_name }}
                              </td>


                              <td class="text-center align-middle">
                                <div v-if="dato.resp_rol === 'Management'">
                                  <h6>Nivel Gerencial
                                  </h6>
                                </div>
                                <div v-else-if="dato.resp_rol === 'Media'">
                                  <h6>Mandos medios
                                  </h6>
                                </div>
                                <div v-else-if="dato.resp_rol === 'Colaborators'">
                                  <h6>Colaboradores
                                  </h6>
                                </div>
                                <div v-else-if="dato.resp_rol === 'Sgsst'">
                                  <h6>Responsable del SG SST
                                  </h6>
                                </div>
                                <div v-else-if="dato.resp_rol === 'Copasst'">
                                  <h6>COPASST
                                  </h6>
                                </div>
                                <div v-else-if="dato.resp_rol === 'Cocola'">
                                  <h6>COCOLA
                                  </h6>

                                </div>
                                <div v-else="dato.resp_rol === 'Brigade'">
                                  <h6> Brigadista
                                  </h6>

                                </div>
                              </td>

                              <td class="text-center align-middle">
                                <div v-if="dato.file === null">
                                  <h6>No hay archivo disponible
                                  </h6>
                                </div>
                                <div v-else>
                                  <button :disabled="!allowAccess()"
                                    style=" background-color: transparent !important; border: none;" type="button"
                                    @click="gotoDigitalOcean(`${dato.resp_link}`)"> <i
                                      class="mdi mdi-cloud-download"></i>
                                  </button>
                                </div>
                              </td>

                              <td class="text-center align-middle">
                                <div class="col-sm-12">
                                  <b-dropdown :disabled="!allowAccess()" variant="primary">
                                    <template v-slot:button-content>
                                      <i class="mdi mdi-eye"></i>
                                    </template>
                                    <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()"
                                      :to="{ path: `/forms/estandares/responsabilidades-sgsst-editar/${dato.id}` }">Editar</b-dropdown-item>

                                  </b-dropdown>
                                </div>
                              </td>
                            </tr>

                          </tbody>
                        </table>
                        <div>
                          <Pagination ref="paginator" @fetch="(items) => (lista = items)" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- end col -->
                </div>
              </form>
            </div>
          </div>

          <!-- ───────── Acta general (tandas) ───────── -->
          <div class="card" v-if="getRole('Consultar') || !allowAccess()">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-start flex-wrap">
                <div>
                  <h5 class="card-title mb-1">Acta general de responsabilidades</h5>
                  <p class="text-muted small mb-2" style="max-width: 640px">
                    La app genera el acta general por tandas (grupos de colaboradores). El encargado la
                    firma electrónicamente; los colaboradores firman a mano por fuera de la plataforma.
                  </p>
                </div>
                <div class="text-right">
                  <span class="badge badge-pill"
                    :class="coverage.pending === 0 && coverage.total > 0 ? 'badge-success' : 'badge-warning'">
                    {{ coverage.covered }}/{{ coverage.total }} con firma en acta general
                  </span>
                  <div v-if="coverage.pending > 0" class="small mt-1">
                    <a href="javascript:void(0)" @click="showPending = !showPending">
                      {{ showPending ? 'Ocultar' : 'Ver' }} {{ coverage.pending }} pendiente(s)
                    </a>
                  </div>
                </div>
              </div>

              <div v-if="showPending && pendingEmployees.length" class="alert alert-warning py-2 small">
                <strong>Sin firma aún:</strong>
                {{ pendingEmployees.map(e => e.full_name).join(', ') }}
              </div>

              <!-- Crear tanda (la app genera el acta; no se sube archivo) -->
              <div class="row mt-2" v-if="getRole('Crear') && allowAccess()">
                <div class="col-md-6">
                  <b-form-group label="Ciudad">
                    <b-form-input v-model="actaForm.city" placeholder="Ciudad"></b-form-input>
                  </b-form-group>
                  <b-form-group label="Fecha del acta">
                    <b-form-input type="date" v-model="actaForm.acta_date"></b-form-input>
                  </b-form-group>
                  <b-form-group label="Socializa (nombre)">
                    <b-form-input v-model="actaForm.socializa" placeholder="Quién socializa el acta"></b-form-input>
                  </b-form-group>
                  <b-form-group label="Cargo de quien socializa">
                    <b-form-input v-model="actaForm.socializa_cargo" placeholder="Cargo"></b-form-input>
                  </b-form-group>
                  <button class="btn btn-primary" :disabled="actaUploading" @click="saveActa">
                    <b-spinner small v-if="actaUploading"></b-spinner>
                    <span v-else>Crear tanda ({{ actaForm.employee_ids.length }} colaboradores)</span>
                  </button>
                </div>

                <div class="col-md-6">
                  <label class="d-block mb-1">Colaboradores que firmaron en esta tanda</label>
                  <div class="d-flex justify-content-between align-items-center mb-1">
                    <b-form-input size="sm" class="w-50" v-model="actaSearch" placeholder="Buscar..."></b-form-input>
                    <b-form-checkbox v-model="showCovered" switch class="small">Incluir ya cubiertos</b-form-checkbox>
                  </div>
                  <div class="acta-emp-list border rounded p-2">
                    <div v-if="!availableEmployees.length" class="text-muted small text-center py-2">
                      No hay colaboradores {{ showCovered ? '' : 'pendientes' }} para mostrar.
                    </div>
                    <b-form-checkbox v-for="e in availableEmployees" :key="e.id"
                      v-model="actaForm.employee_ids" :value="e.id" class="small d-block">
                      {{ e.full_name }}
                      <span v-if="coveredIds.has(e.id)" class="badge badge-light text-success">ya firmó</span>
                    </b-form-checkbox>
                  </div>
                </div>
              </div>

              <hr />

              <!-- Tandas subidas -->
              <div class="table-responsive">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th class="text-center">Fecha</th>
                      <th class="text-center">Nº colab.</th>
                      <th class="text-center">Colaboradores</th>
                      <th class="text-center">Documento</th>
                      <th class="text-center">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="!actas.length">
                      <td colspan="5" class="text-center text-muted">Aún no se ha creado ninguna tanda del acta general.</td>
                    </tr>
                    <tr v-for="acta in actas" :key="acta.id">
                      <td class="text-center align-middle">
                        {{ acta.acta_date ? dateConvert(acta.acta_date) : dateConvert(acta.created_at) }}
                      </td>
                      <td class="text-center align-middle">{{ acta.signature_count }}</td>
                      <td class="align-middle">
                        <span v-for="e in acta.employees" :key="e.id" class="badge badge-light mr-1 mb-1">
                          {{ e.full_name }}
                        </span>
                      </td>
                      <td class="text-center align-middle" style="min-width: 210px;">
                        <DocumentActions
                          :document-id="acta.id"
                          :company-id="companyID"
                          :workflow-status="acta.workflow_status || 'draft'"
                          :signed-at="acta.signed_at"
                          :api-service="actaApi"
                          document-title="Acta general de responsabilidades"
                          signer-role="gerente"
                          @signed="(p) => onActaSigned(acta, p)"
                        />
                        <a v-if="acta.file_link" href="javascript:void(0)" class="d-block mt-1 small"
                          @click="gotoDigitalOcean(acta.file_link)" title="Descargar archivo cargado anteriormente">
                          <i class="mdi mdi-cloud-download"></i> Descargar archivo cargado
                        </a>
                      </td>
                      <td class="text-center align-middle">
                        <button :disabled="!getRole('Editar') || !allowAccess()" type="button"
                          class="btn btn-sm btn-outline-danger" @click="deleteActa(acta.id)">
                          <i class="mdi mdi-trash-can"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
.acta-emp-list {
  max-height: 220px;
  overflow-y: auto;
}
</style>